<template>
  <div
    class="flex flex-col rounded-md border border-light-gray p-4 shadow-primary"
  >
    <p class="mb-2 text-left text-1lg text-dark-blue">Edit My Details</p>
    <template v-if="lastestInquiryStatus == 'approved'">
      <label
        class="w-full text-left text-2xs font-bold uppercase text-gray-over-dark"
      >
        Name
      </label>
      <div
        class="mb-3 mt-2 w-full rounded-md border border-transparent bg-off-white p-4 text-sm text-gray-over-dark"
      >
        <p class="text-left text-1md">
          {{ accountDetails.full_name }}
        </p>
      </div>
    </template>
    <form-field
      v-else
      label="Name"
      :value="accountDetails.full_name"
      placeholder="Enter Name"
      :on-input="onInput"
      name="full_name"
    />
    <form-field
      v-if="lastestInquiryStatus == 'approved'"
      label="Preferred Name"
      :value="accountDetails.preferred_name"
      placeholder="Enter Preferred Name"
      :on-input="handlePreferredName"
      name="preferred_name"
    />
    <label
      class="w-full text-left text-2xs font-bold uppercase text-gray-over-dark"
    >
      Email
    </label>
    <div
      class="mb-3 mt-2 w-full rounded-md border border-transparent bg-off-white p-4 text-sm text-gray-over-dark"
    >
      <p class="text-left text-1md">
        {{ email }}
      </p>
    </div>
    <label
      class="w-full text-left text-2xs font-bold uppercase text-gray-over-dark"
    >
      Company Name
    </label>
    <div
      class="mt-1 w-full rounded-md border border-transparent bg-off-white p-4 text-sm text-gray-over-dark"
    >
      <p class="text-left text-1md">
        {{ companyName }}
      </p>
    </div>
    <div class="mt-6 flex justify-end gap-2">
      <button-main
        size="md"
        class="text-1md"
        variant="secondary"
        @click="toggleEditOff"
      >
        Cancel
      </button-main>
      <button-main
        size="md"
        class="text-1md"
        @click="updateInformation"
      >
        Save
      </button-main>
    </div>
  </div>
</template>

<script type="text/javascript">
import FormField from '@/components/FormField.vue';
import ProfileMixin from '@/mixins/profile';
import ButtonMain from '@/components/Button.vue';

// Common
import { fullNameFormat } from '@/common/textFormater';
import { toastResponse } from '@/common/handleServerResponse';
import { formatFirstLastName } from '@/common/validators';

export default {
  name: 'EditProfile',
  components: {
    FormField,
    ButtonMain,
  },
  mixins: [ProfileMixin],
  data() {
    return {
      accountDetails: {
        full_name: '',
        email: '',
        preferred_name: '',
      },
    };
  },
  computed: {
    preferredName() {
      return this.$store.state.users.currentUser.preferred_name;
    },
    lastestInquiryStatus() {
      return this.$store.getters['users/inquiryStatus'];
    },
    userId() {
      return this.$store.state.users.currentUser?.id || '';
    },
  },
  created() {
    this.accountDetails['full_name'] = this.full_name;
    this.accountDetails['preferred_name'] = this.preferredName;
  },
  methods: {
    isFullNameField(fieldName) {
      const name = fieldName.toLowerCase();
      if (name.includes('full') && name.includes('name')) {
        return true;
      }
      return false;
    },
    toggleEditOff() {
      this.$parent.toggleEditOff();
    },
    async updateInformation() {
      const statusToUpdate = new Set(['approved', 'declined']);
      if (statusToUpdate.has(this.lastestInquiryStatus)) {
        console.log('Preffe', this.accountDetails['preferred_name']);
        const res = await this.$store.dispatch(
          'users/updatePreferredName',
          this.accountDetails['preferred_name']
        );
        toastResponse(this, res, 'User information updated');
        await this.$store.dispatch('users/serverRefreshCurrentUser');
        this.toggleEditOff();
        return;
      }

      if (!this.accountDetails['full_name'])
        this.accountDetails['full_name'] = this.full_name;
      const { first_name, last_name } = formatFirstLastName(
        this.accountDetails['full_name']
      );
      const res = await this.$store.dispatch('users/updateProfileInformation', {
        first_name,
        last_name,
        user_id: this.userId,
      });
      toastResponse(this, res, 'User information updated');
      await this.$store.dispatch('users/serverRefreshCurrentUser');
      this.toggleEditOff();
    },
    onInput(e) {
      let value = e.target.value;
      if (this.isFullNameField(e.target.name)) {
        value = fullNameFormat(value);
      }
      this.accountDetails[e.target.name] = value;
    },
    handlePreferredName(e) {
      this.accountDetails['preferred_name'] = e.target.value;
    },
  },
};
</script>
